/** 
 * Classe com métodos úteis que podem ser utilizados
 * em qualquer módulo do sistema.
 * 
 * @module Util
 */
var Util = (function () {
    return {
        /**
         * Adiciona uma classe no objeto.
         * @param {object} obj - Recebe o objeto que ganhará uma classe
         * @param {string} className - Recebe o nome da classe
         */
        addClass: function (obj, className) {
            if (obj.classList)
                obj.classList.add(className);
            else
                obj.className += ' ' + className;
        },

        /**
         * Verifica se uma classe já existe no objeto.
         * @param {object} obj - Recebe o objeto a ser verificado
         * @param {string} className - Recebe o nome da classe
         */
        hasClass: function (obj, className) {
            if (obj.classList)
                return obj.classList.contains(className);
            else
                return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
        },

        /**
         * Remove uma classe no objeto.
         * @param {object} obj - Recebe o objeto que terá a classe removida
         * @param {string} className - Recebe o nome da classe
         */
        removeClass: function (obj, className) {
            if (obj.classList)
                obj.classList.remove(className);
            else
                obj.className = obj.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },

        /**
         * Remove ou adiciona uma classe no objeto.
         * @param {object} obj - Recebe o objeto que terá a classe removida
         * @param {string} className - Recebe o nome da classe
         */
        toggleClass: function (obj, className) {
            if (obj.classList) {
                obj.classList.toggle(className);
            }
            else {
                var classes = obj.className.split(' ');
                var existingIndex = -1;

                for (var i = classes.length; i--;) {
                    if (classes[i] === className)
                        existingIndex = i;
                }

                if (existingIndex >= 0)
                    classes.splice(existingIndex, 1);
                else
                    classes.push(className);

                obj.className = classes.join(' ');
            }
        },

        /**
         * Leva o scroll da página até um elemento
         * @param {object} element - ex: document.querySelector('.element')
         */
        scrollToElement(element) {
            const elementoTop = element.getBoundingClientRect().top;
            const offset = window.scrollY;
            const finalTop = elementoTop + offset;

            window.scrollTo({
                top: finalTop,
                behavior: 'smooth'
            });
        }
    }
})();

/** 
 * Classe com métodos do HEADER do portal
 * 
 * @module Header
 */
var Header = (function () {
    return {

        /**
         * Manipula as classes da abertura do menu mobile
         * @param {object} obj - Recebe o objeto
         */
        OpenMenuMobile: function (obj) {
            Util.toggleClass(document.querySelector(".main-header"), "-open");
        }
    }
})();